import { r as registerInstance, h, F as Fragment } from './index-5faac9d7.js';
import { t as tryParse, aB as RequestServiceInstance } from './index-e29b327a.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';

const GlobalsConfigurator = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._APIConfigList = undefined;
  }
  componentWillLoad() {
    var _a;
    const APIConfigList = (_a = tryParse(this._APIConfigList)) !== null && _a !== void 0 ? _a : this._APIConfigList;
    for (const APIConfig of APIConfigList) {
      try {
        RequestServiceInstance.setUpAPI(APIConfig);
      }
      catch (error) {
        console.error(`[PES]: Could not setup API ${APIConfig}`, error);
      }
    }
  }
  render() {
    return h(Fragment, null);
  }
};

export { GlobalsConfigurator as pes_globals_configurator };
